import * as React from "react";
import type { SVGProps } from "react";
export const SvgLolRanksBronze = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="#8C513A"
      fillRule="evenodd"
      d="M6.091 11.287c0-.578.13-1.148.38-1.67s.614-.982 1.065-1.348C5.612 7.597 2.812 6.259 1.999 4c0 0-.173 2.289 1.211 4.85 0 0 1.473.955 2.061 2.244l-1.144-.7c.29.92.644 1.816 1.061 2.685.664 1.268 1.903 2.227 1.903 2.227s-.576-1.713.1-1.302l.066.045a3.86 3.86 0 0 1-1.168-2.77l.002.008Zm6.422-3.035c.457.365.827.828 1.08 1.353a3.87 3.87 0 0 1 .243 2.724 3.877 3.877 0 0 1-.936 1.629c.5-.156 0 1.35 0 1.35s1.237-.963 1.903-2.227c.418-.868.772-1.765 1.061-2.683l-1.135.685c.594-1.281 2.054-2.233 2.054-2.233C18.167 6.289 17.994 4 17.994 4c-.8 2.239-3.56 3.573-5.481 4.252Zm.212 3.035c0 1.471-1.204 2.664-2.69 2.664s-2.69-1.193-2.69-2.664 1.204-2.664 2.69-2.664 2.69 1.193 2.69 2.664Z"
      clipRule="evenodd"
    />
  </svg>
);
